function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 5,
  fill: "#64B5F6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.047 27.84c-2.694 0-5.388.004-8.08 0-1.646-.004-2.45-1.338-1.662-2.803 2.74-5.1 5.484-10.197 8.281-15.263.27-.488.938-.88 1.419-.88.48 0 1.143.4 1.411.885 2.77 5.01 5.48 10.06 8.197 15.102.915 1.698.159 2.956-1.76 2.957l-7.806.002zm-1.597-9.855h-.007V20c0 .061 0 .122.007.183.082.821.663 1.388 1.413 1.379.738-.009 1.309-.519 1.334-1.335.043-1.463.044-2.927.003-4.392-.025-.867-.612-1.393-1.384-1.376-.754.016-1.319.577-1.36 1.423-.035.696-.007 1.4-.007 2.101l.001.002zm2.998 5.807a1.418 1.418 0 00-1.332-1.442 1.415 1.415 0 00-1.511 1.353c-.028.768.645 1.458 1.421 1.457.739-.002 1.398-.636 1.42-1.37l.002.002z",
  fill: "#E3F2FD"
});

function SvgPlaybook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgPlaybook;